const keyFor=id=>'bpa-assessment-draft-v2:'+(id||'timesheet-to-invoice');
// Static frontend only. Secure email handling takes place in the existing
// PocketBase hook on PocketHost, never in a Netlify Function or the browser.
const POCKETBASE='https://population-coming-bpa-email-gateway-mask.pockethost.io';
const DEFAULT_API=POCKETBASE+'/api/bpa-mail/assessment/submit';
const configured=String(import.meta.env.VITE_BPA_EMAIL_GATEWAY_URL||'').trim().replace(/\/$/,'');
function resolveGatewayUrl(raw){
 if(!raw)return DEFAULT_API;
 try{
  const u=new URL(raw);
  if(u.protocol!=='https:')return DEFAULT_API;
  if(u.hostname==='emailgateway.bpasolutions.au'||u.hostname==='genuine-daffodil-fd5d8b.netlify.app')return DEFAULT_API;
  if(u.pathname==='/'||u.pathname==='/apps'||u.pathname.includes('/.netlify/functions/'))return DEFAULT_API;
  if(u.pathname==='/api/bpa-mail/send'||u.pathname==='/api/bpa-mail/assessment/submit'){
   u.pathname='/api/bpa-mail/assessment/submit';u.search='';u.hash='';
   return u.toString();
  }
 }catch{ /* invalid legacy URL */ }
 return DEFAULT_API;
}
const API=resolveGatewayUrl(configured);
export const backendConfigured=Boolean(API);
export function loadDraft(id){try{return JSON.parse(localStorage.getItem(keyFor(id))||'null');}catch{return null;}}
export function saveDraft(draft,id){localStorage.setItem(keyFor(id),JSON.stringify(draft));}
export function clearDraft(id){localStorage.removeItem(keyFor(id));}
export async function postAssessment(payload){
 if(!API)throw new Error('Report email service is not configured.');
 const response=await fetch(API,{method:'POST',cache:'no-store',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
 const result=await response.json().catch(()=>({}));
 if(!response.ok||result.success!==true)throw new Error(result.message||'The report could not be queued for email delivery.');
 return {emailed:result.data?.emailed===true,queued:result.data?.queued===true,persisted:false};
}